module.exports = __webpack_public_path__ + "static/img/应用于园艺种植生长环境模型.dfdcb47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert/应用于园艺种植生长环境模型.jpg
// module id = 3dJ4
// module chunks = 15